<template>
  <form novalidate @submit.prevent="cancelService">
    <LsModal title="Cancel Subscription" track-id="cancel_subscription_modal_step_two">
      <template #body>
        <LsSelect
          v-model="reason"
          label="What is the reason for your cancellation?"
          track-id="cancel_subscription_modal_step_two-reason"
          :options="reasonOptions"
          name="reasons"
          :validation="{ required: true }"
          placeholder="Please select a reason..."
        />
        <BCollapse :open="reason === 'other'">
          <LsInput
            v-model="notes"
            label="Please provide additional details"
            type="textarea"
            track-id="cancel_subscription_modal_step_two-notes"
            name="notes"
            :validation="{ required: reason === 'other' }"
            style="margin-bottom: 12px;"
            class="cancel-subscription-modal-step-two--textarea"
          />
        </BCollapse>
        <BField
          :label="
            `How likely is it that you would recommend ${brandName} to a friend or colleague?`
          "
          class="cancel-subscription-modal-step-two--satisfaction"
          :type="{ 'is-error': errors.has('satisfaction') }"
          :message="errors.has('satisfaction') ? 'This is required' : ''"
        >
          <BRadioButton
            v-for="number in satisfactionOptions"
            :key="number"
            v-model="satisfaction"
            v-validate="'required'"
            :native-value="number"
            name="satisfaction"
          >
            {{ number }}
          </BRadioButton>
        </BField>
        <LsRadioButtons
          v-model="plans_to_hire_other_provider"
          label="Do you plan to hire another lawn care company?"
          track-id="cancel_subscription_modal_step_two-plans_to_hire_other_provider"
          :options="booleanOptions"
          name="plans_to_hire_other_provider"
          :validation="{ required: true }"
          style="margin-bottom: 10px;"
        />
        <LsInput
          v-model="notes_good"
          label="What did we do well?"
          type="textarea"
          track-id="cancel_subscription_modal-notes_good"
          name="notes_good"
          class="cancel-subscription-modal-step-two--textarea"
        />
        <LsInput
          v-model="notes_improve"
          label="What could we do better?"
          type="textarea"
          track-id="cancel_subscription_modal_step_two-notes_improve"
          name="notes_improve"
          class="cancel-subscription-modal-step-two--textarea"
        />
      </template>
      <template #footer>
        <LsButton
          text="yes, cancel my subscription"
          track-id="cancel_subscription_modal_step_two-yes_cancel_my_subscription"
          type="submit"
          :loading="support.loadingStatus.isUpdating"
        />
      </template>
    </LsModal>
  </form>
</template>

<script>
import { LsButton, LsModal, LsInput, LsRadioButtons, LsSelect } from '@/components/common';
import { mapState } from 'vuex';
import VueTypes from 'vue-types';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'CancelSubscriptionModalStepTwo',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsButton,
    LsModal,
    LsInput,
    LsRadioButtons,
    LsSelect,
  },
  mixins: [themedComponentMixin],
  props: {
    next: VueTypes.func.isRequired,
  },
  data() {
    return {
      reason: null,
      notes: '',
      plans_to_hire_other_provider: null,
      satisfaction: '',
      notes_good: '',
      notes_improve: '',
    };
  },
  computed: {
    ...mapState(['support']),
    reasonOptions() {
      return [
        { label: 'Moving', value: 'moving' },
        { label: 'Quality of Service', value: 'quality' },
        { label: 'Scheduling Issues', value: 'scheduling' },
        { label: 'Pricing, too expensive', value: 'pricing' },
        { label: `${this.brandName}'s Customer Support`, value: 'customer_service' },
        { label: `${this.brandName}'s policies don't work for me`, value: 'badfit_policy' },
        {
          label: 'Planned to use only for specific length of time',
          value: 'planned',
        },
        { label: 'Other', value: 'other' },
      ];
    },
    satisfactionOptions() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    },
    booleanOptions() {
      return [{ label: 'No', value: false }, { label: 'Yes', value: true }];
    },
  },
  methods: {
    async cancelService() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return;
      }

      this.next({
        reason: this.reason,
        notes: this.notes,
        plans_to_hire_other_provider: this.plans_to_hire_other_provider,
        satisfaction: this.satisfaction,
        notes_good: this.notes_good,
        notes_improve: this.notes_improve,
      });
    },
  },
};
</script>

<style lang="scss">
.cancel-subscription-modal-step-two--textarea {
  .textarea:not([rows]) {
    min-height: 80px;
  }
}

.cancel-subscription-modal-step-two--satisfaction {
  flex-wrap: wrap;
  .label {
    flex-basis: 100%;
  }

  .is-error {
    flex-basis: 100%;
  }

  .button {
    color: $primary;
    border-radius: 0px;
    border: 0px;
    border-right: 1px solid $primary-light;
    min-width: 40px !important;
    width: 40px;
    height: 35px;
    margin: 0 1px;
    font-size: $size-3;
    &:hover {
      background-color: $primary;
      color: $white;
    }
    &.is-primary {
      background-color: $primary;
      color: $white;
    }

    @media (max-width: $mobile-max-width) {
      min-width: 29px !important;
      width: 29px;
      font-size: $size-4;
    }
  }

  .control:nth-child(11) label {
    border: 0px;
  }
}

.themed-app {
  .cancel-subscription-modal-step-two--satisfaction {
    .button {
      color: $theme-color-primary;
      border-color: $theme-color-primary-light;
      font-size: $theme-txt-title-sm;
      &:hover {
        background-color: $theme-color-primary;
        color: $theme-color-white;
      }
      &.is-primary {
        background-color: $theme-color-primary;
        color: $theme-color-white;
      }

      @media (max-width: $mobile-max-width) {
        font-size: $theme-txt-body-lg;
      }
    }
  }
}
</style>
